export const firebaseRc: Record<string, string> = {
  'frc.tab.editor': 'Trình sửa RC',
  'frc.tab.settings': 'Cài đặt',

  // Project picker
  'frc.search': 'Tìm project ID / tên',
  'frc.filterCategory.all': 'Tất cả nhóm',
  'frc.noProjects': 'Bạn chưa được gán project nào.',
  'frc.selectProjectHint': 'Chọn một project để xem Remote Config.',
  'frc.noCategory': '(Chưa phân nhóm)',

  // Editor grid
  'frc.param': 'Tham số',
  'frc.type': 'Kiểu',
  'frc.defaultValue': 'Giá trị mặc định',
  'frc.noParams': 'Không có tham số cấp cao nhất.',
  'frc.readonly': 'Chỉ đọc — bạn không phải editor của project này.',
  'frc.loading': 'Đang tải…',

  // Publish
  'frc.publish': 'Xuất bản',
  'frc.publishing': 'Đang xuất bản…',
  'frc.discard': 'Hủy thay đổi',
  'frc.unsaved': 'thay đổi chưa lưu',
  'frc.publishOk': 'Xuất bản thành công',
  'frc.conflictReload': 'Template đã bị người khác thay đổi — đã tải lại bản mới nhất.',

  // Admin structural
  'frc.addParam': 'Thêm tham số',
  'frc.addCondition': 'Thêm điều kiện',
  'frc.deleteParam': 'Xóa',
  'frc.confirmDeleteParam': 'Xóa tham số này?',
  'frc.conditionName': 'Tên',
  'frc.expression': 'Biểu thức (CEL)',

  // Value popup + JSON
  'frc.json.valid': 'JSON hợp lệ',
  'frc.json.format': 'Định dạng',

  // JSON + versions
  'frc.viewJson': 'Xem JSON',
  'frc.versions': 'Phiên bản',
  'frc.rollback': 'Khôi phục',
  'frc.confirmRollback': 'Khôi phục về phiên bản #',
  'frc.when': 'Thời điểm',
  'frc.who': 'Người sửa',

  // Settings
  'frc.settings.allowlist': 'Danh sách Editor',
  'frc.settings.assignments': 'Gán project',
  'frc.settings.categories': 'Nhóm',
  'frc.settings.addCategory': 'Thêm',
  'frc.settings.allowlistDesc': 'Nhân sự MONET được phép sửa Remote Config (vẫn cần được gán project bên dưới).',
  'frc.settings.assignmentsDesc': 'Gán editor cho từng project. Editor chỉ thấy project được gán.',
  'frc.settings.categoriesDesc': 'Thêm/xóa nhóm để phân loại project. Không xóa được nhóm đang dùng.',

  // Project auto-sync
  'frc.sync.title': 'Project Firebase',
  'frc.sync.desc': 'Danh sách project tự đồng bộ từ Firebase 1 lần/ngày (chỉ app đang active). Bấm để làm mới ngay.',
  'frc.sync.now': 'Đồng bộ từ Firebase',
  'frc.sync.running': 'Đang đồng bộ…',
  'frc.sync.done': 'Đã đồng bộ',
  'frc.category': 'Nhóm',
  'frc.archived': 'Đã lưu trữ',
  'frc.save': 'Lưu',
  'frc.saved': 'Đã lưu',

  // Tài liệu tham số (Confluence)
  'frc.docs.title': 'Tài liệu tham số (Confluence)',
  'frc.docs.open': 'Xem tài liệu tham số này',
  'frc.docs.refresh': 'Đồng bộ lại',
  'frc.docs.platform': 'Nền tảng',
  'frc.docs.page': 'Trang Confluence',
  'frc.docs.sections': 'Mục',
  'frc.docs.sourceChild': 'Trang con',
  'frc.docs.sourceSection': 'Mục cắt ra',
  'frc.docs.synced': 'đồng bộ',
  'frc.docs.never': 'Chưa đồng bộ',
  'frc.docs.notConfigured': 'Project này chưa gán nền tảng nên không có trang tài liệu tương ứng.',
  'frc.docs.notSynced': 'Chưa đồng bộ tài liệu cho nền tảng này. Admin bấm Đồng bộ lại trong Settings.',
  'frc.docs.noMatch': 'Không có mục tài liệu nào khớp',
  'frc.docs.toc': 'Mục lục',
}
